import { EyeIcon, EyeSlashIcon } from "@phosphor-icons/react";
import { Button, Field, Input } from "@bafe/ui";
import { type ReactNode, useState } from "react";

export interface PasswordFieldProps {
	label: string;
	value: string;
	onChange: (value: string) => void;
	help?: ReactNode;
	error?: string | null;
	autoComplete?: string;
	required?: boolean;
	name?: string;
	action?: ReactNode;
}

export function PasswordField({
	label,
	value,
	onChange,
	help,
	error,
	autoComplete = "new-password",
	required,
	name,
	action,
}: PasswordFieldProps) {
	const [visible, setVisible] = useState(false);

	return (
		<Field label={label} help={help} error={error} required={required} action={action}>
			{({ id, describedBy, invalid }) => (
				<div className="flex items-center gap-2">
					<Input
						id={id}
						name={name}
						type={visible ? "text" : "password"}
						value={value}
						required={required}
						autoComplete={autoComplete}
						aria-describedby={describedBy}
						aria-invalid={invalid}
						onChange={(event) => onChange(event.target.value)}
						className={visible ? "font-mono" : undefined}
					/>
					<Button
						type="button"
						variant="secondary"
						size="md"
						onClick={() => setVisible((current) => !current)}
						aria-pressed={visible}
						className="shrink-0 px-3"
						iconLeft={
							visible ? (
								<EyeSlashIcon className="size-4" aria-hidden="true" />
							) : (
								<EyeIcon className="size-4" aria-hidden="true" />
							)
						}
					>
						<span className="sr-only">{visible ? "Hide password" : "Show password"}</span>
					</Button>
				</div>
			)}
		</Field>
	);
}
